import 'css-chunksrc/client/pages/projectPage/styles.scss';export default {
  "projectPage": "_projectPage_v9yks_1",
  "header": "_header_v9yks_8",
  "menu": "_menu_v9yks_17",
  "separatorArrow": "_separatorArrow_v9yks_21",
  "profileNavigation": "_profileNavigation_v9yks_30",
  "project": "_project_v9yks_1",
  "zone": "_zone_v9yks_52",
  "zoneWrapper": "_zoneWrapper_v9yks_59",
  "projectName": "_projectName_v9yks_64",
  "projectIcon": "_projectIcon_v9yks_70",
  "wrapper": "_wrapper_v9yks_77",
  "sideBar": "_sideBar_v9yks_84",
  "main": "_main_v9yks_91",
  "membersList": "_membersList_v9yks_99",
  "gantt": "_gantt_v9yks_104",
  "kanban": "_kanban_v9yks_111",
  "listsList": "_listsList_v9yks_116",
  "loader": "_loader_v9yks_121",
  "loaderMain": "_loaderMain_v9yks_129",
  "scenePlaceholder": "_scenePlaceholder_v9yks_136"
};